export default __webpack_public_path__ + "static/media/he-she-subject.d9339a22.png";